/*
 * @Descripttion:
 * @version:
 * @Author: wanglikun
 * @Date: 2022-06-01 08:28:56
 * @LastEditors: sueRimn
 * @LastEditTime: 2022-07-02 16:48:08
 */
import request from '../request'
const { VITE_APP_API_BASE_URL } = import.meta.env
const GET_I18N = VITE_APP_API_BASE_URL.replace('/boxadmin', '') + '/i18n/sysInternational/getSysInternationalList'
export default class dictService {
  /**
   * 获取字典page
   * @param data
   * @returns
   */
  static dict_page(data: any): Promise<any> {
    return request.post('/dict/page', data)
  }
  /**
   * 新增字典
   * @param data
   * @returns
   */
  static dict_save(data: any): Promise<any> {
    return request.post('/dict/save', data)
  }
  /**
   * 字典更新
   * @param data
   * @returns
   */
  static dict_update(data: any): Promise<any> {
    return request.post('/dict/update', data)
  }
  /**
   * 字典删除
   * @param data
   * @returns
   */
  static dict_delete(data: any): Promise<any> {
    return request.post('/dict/delete', data)
  }
  /**
   * 获取i18n数据
   * @param data
   * @returns
   */
  static getI18n(data: any): Promise<any> {
    return request.get(GET_I18N, data)
  }
  /**
   * 字典值列表
   * @param data
   * @returns
   */
  static dict_value_page(data: any): Promise<any> {
    return request.post(`/dictValue/page`, data)
  }
  /**
   * 新增字典值
   * @param data
   * @returns
   */
  static dict_value_save(data: any): Promise<any> {
    return request.post(`/dictValue/save`, data)
  }
  /**
   * 更新字典值
   * @param data
   * @returns
   */
  static dict_value_update(data?: any): Promise<any> {
    return request.post(`/dictValue/update`, data)
  }
  /**
   * 删除字典值
   * @param data
   * @returns
   */
  static dict_value_delete(data?: any): Promise<any> {
    return request.post(`/dictValue/delete`, data)
  }
  /**
   * 提供数据字典列表供其他接口调用
   * @param data
   * @returns
   */
  static dict_value_list(data?: any): Promise<any> {
    return request.get(`/dictValue/getDictValueList`, data)
  }
  /**
   * redis缓存刷新
   * @param data
   * @returns
   */
  static dict_value_refresh(data?: any): Promise<any> {
    return request.post(`/dictValue/refresh`, data)
  }
  /**
   * 获取枚举
   * @param data
   * @returns
   */
  static listEnum(data?: any): Promise<any> {
    return request.post(`/dictValue/listEnum`, data)
  }
}
